import { render, staticRenderFns } from "./FiguresAndCharts.vue?vue&type=template&id=850e0778&scoped=true&"
import script from "./FiguresAndCharts.vue?vue&type=script&lang=js&"
export * from "./FiguresAndCharts.vue?vue&type=script&lang=js&"
import style0 from "./FiguresAndCharts.vue?vue&type=style&index=0&id=850e0778&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "850e0778",
  null
  
)

export default component.exports